import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import GridView from "@mnjsplatform/components/lib/common/GridView/GridView";
import PlaceholderWrapper from "../../Common/PlaceholderWrapper";
import ComplexParam from "@mnjsplatform/components/lib/common/ComplexParam";
import SearchBar from "@mnjsplatform/components/lib/common/SearchBar";
import i18next from "i18next";

class SubDayOff extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {}
    }

    componentDidMount() {
        this.initialize();
    }

    async initialize() {
        try {
            await this.props.dispatch(this.props.WorkHoliday_ListForBossTotalPoNew.execute({}, {withParams: true}));
        } catch (e) {
            console.error(e);
        }
    }

    renderParams = (h) => {

        let fiNames = {};

        h.fs.forEach((item) => {
            fiNames[item.Name] = item.Name;
        });

        let searchBarFieldNames = {TFIO: 1, Department: 1, JobTitle: 1, WorkHour: 1, HolHour: 1, RestHour: 1};
        let searchBarFieldSet = this.props.WorkHoliday_ListForBossTotalPoNew.rawData.ResultFieldInfo.filter(f => searchBarFieldNames[f.Name] != null)
            .map(f => f.Name);

        return (<>
            <div className="row">
                <div className="col-md-12">
                    <div className="field-title"
                         style={{display: 'inline-block'}}>{h.lbl(fiNames.DateBeginShow)}</div>
                    <div style={{display: 'inline-block', marginLeft: '10px'}}>{h.ed(fiNames.DateBeginShow)}</div>
                    <div className="field-title"
                         style={{display: 'inline-block', marginLeft: '10px'}}>{i18next.t("SubDayOff_To")}</div>
                    <div style={{display: 'inline-block', marginLeft: '10px'}}>{h.ed(fiNames.DateEndShow)}</div>
                </div>
            </div>
            <div className="row" style={{marginTop: '7px'}}>
                <div className="col-md-6">
                    <div className="field-title" style={{textAlign: 'left'}}>{h.lbl(fiNames.NumSub)}</div>
                    <div>{h.ed(fiNames.NumSub)}</div>
                </div>
                <div className="col-md-6">
                    <div className="field-title" style={{textAlign: 'left'}}>{h.lbl(fiNames.AdmStructName)}</div>
                    <div>{h.ed(fiNames.AdmStructName)}</div>
                </div>
            </div>
            <div className="row" style={{marginTop: '7px'}}>
                <div className="col-md-12">
                    <div style={{display: 'inline-block', marginRight: '10px'}}>{h.ed(fiNames.IsJoin)}</div>
                    <div className="field-title" style={{display: 'inline-block'}}>{h.lbl(fiNames.IsJoin)}</div>
                </div>
            </div>
            <div className="row" style={{marginTop: '15px'}}>
                <div className="col-md-12">
                    <div className="field-title" style={{textAlign: 'left'}}>{i18next.t("SubordinateSearch")}</div>
                    <SearchBar dataItem={this.props.WorkHoliday_ListForBossTotalPoNew} fieldSet={searchBarFieldSet}
                               autoFields={false}/>
                </div>
            </div>
        </>);
    };

    renderData = () => {
        return (<>
            <ComplexParam parentDataItem={this.props.WorkHoliday_ListForBossTotalPoNew}
                          dataItem={this.props.WorkHoliday_ListForBossTotalPoNewParams}
                          renderParams={this.renderParams}
                          showApplyButton={false}
                          autoApplyParams={true}
                          readOnly={false}
                          showSearchBar={true}
                          rootPath="/"/>
            <span>&nbsp;</span>
            <GridView dataItem={this.props.WorkHoliday_ListForBossTotalPoNew}/>
        </>);
    };

    render() {
        let isInitialized = this.props.WorkHoliday_ListForBossTotalPoNew.isInitialized;

        return (<React.Fragment>
            <PlaceholderWrapper placeholderId="10"
                                title={i18next.t("SubDayOff_Title")}
                                showInstruction={false}
                                showSplitterLine={false} canCollapse={false}>
                {isInitialized ? this.renderData() : <span>{i18next.t("DataLoading")}</span>}
            </PlaceholderWrapper>
        </React.Fragment>);
    }
}

SubDayOff.propTypes = {
    dispatch: PropTypes.func.isRequired,
    WorkHoliday_ListForBossTotalPoNew: PropTypes.object,
    WorkHoliday_ListForBossTotalPoNewParams: PropTypes.object
};

SubDayOff.defaultProps = {};

function mapStateToProps(state, ownProps) {
    return {
        WorkHoliday_ListForBossTotalPoNew: state.subDayOffState.WorkHoliday_ListForBossTotalPoNew,
        WorkHoliday_ListForBossTotalPoNewParams: state.subDayOffState.WorkHoliday_ListForBossTotalPoNewParams,
    }
}

export default connect(mapStateToProps)(SubDayOff)